<template>
    <MenuBar />
    <FloatingButton />
    <MainBanner />
    <WhoIsFH />
    <Bottom />
</template>

<script>
import MainBanner from "./components/MainBanner.vue";
import WhoIsFH from "./components/WhoIsFH.vue";
import FloatingButton from "./components/FloatingButton.vue";
import MenuBar from "./components/NavBar.vue";
import Bottom from "./components/BottomInformation.vue";

export default {
    name: "App",
    components: { MainBanner, WhoIsFH, FloatingButton, MenuBar, Bottom },
};
</script>
<script setup></script>

<style>
body {
    overflow-x: hidden;
    overflow-y: scroll;
}
body::-webkit-scrollbar {
    width: 10px;
}
body::-webkit-scrollbar-thumb {
    border-radius: 100px !important;
    background: rgb(122, 216, 255) !important;
    background: linear-gradient(0deg, rgba(122, 216, 255, 1) 0%, rgba(95, 255, 211, 1) 100%) !important;
}
body::-webkit-scrollbar-track {
    background: rgb(255, 255, 255);
    /* background: rgb(122, 216, 255);
    background: linear-gradient(0deg, rgba(122, 216, 255, 1) 0%, rgba(95, 255, 211, 1) 100%); */
}

p,
h1,
h2,
h3,
h4,
h5 {
    font-family: "Do Hyeon";
}

@import url("https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Gowun+Dodum&family=Grandiflora+One&display=swap');
</style>
